var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var getTooltipPosition = function (position, targetPosition, tooltipDimensions) {
    var top, left, transform;
    switch (position) {
        case 'top':
            top = "".concat(targetPosition.top - tooltipDimensions.height, "px");
            left = "".concat(targetPosition.left, "px");
            transform = 'translate(-50%, -13px)';
            break;
        case 'top-start':
            top = "".concat(targetPosition.top - tooltipDimensions.height, "px");
            left = "".concat(targetPosition.left - tooltipDimensions.width, "px");
            transform = "translate(25px, -13px)";
            break;
        case 'top-end':
            top = "".concat(targetPosition.top - tooltipDimensions.height, "px");
            left = "".concat(targetPosition.left - 25, "px");
            transform = "translate(0, -13px)";
            break;
        case 'bottom':
            top = "".concat(targetPosition.top, "px");
            left = "".concat(targetPosition.left, "px");
            transform = "translate(-50%, 13px)";
            break;
        case 'bottom-start':
            top = "".concat(targetPosition.top, "px");
            left = "".concat(targetPosition.left - tooltipDimensions.width, "px");
            transform = "translate(25px, 13px)";
            break;
        case 'bottom-end':
            top = "".concat(targetPosition.top, "px");
            left = "".concat(targetPosition.left - 25, "px");
            transform = "translate(0, 13px)";
            break;
        case 'left':
            top = "".concat(targetPosition.top, "px");
            left = "".concat(targetPosition.left - tooltipDimensions.width, "px");
            transform = "translate(-13px, -50%)";
            break;
        case 'left-start':
            top = "".concat(targetPosition.top - tooltipDimensions.height, "px");
            left = "".concat(targetPosition.left - tooltipDimensions.width, "px");
            transform = "translate(-13px, 25px)";
            break;
        case 'left-end':
            top = "".concat(targetPosition.top + tooltipDimensions.height - 25, "px");
            left = "".concat(targetPosition.left - tooltipDimensions.width, "px");
            transform = "translate(-13px, -100%)";
            break;
        case 'right':
            top = "".concat(targetPosition.top, "px");
            left = "".concat(targetPosition.left, "px");
            transform = "translate(13px, -50%)";
            break;
        case 'right-start':
            top = "".concat(targetPosition.top - tooltipDimensions.height, "px");
            left = "".concat(targetPosition.left, "px");
            transform = "translate(13px, 25px)";
            break;
        case 'right-end':
            top = "".concat(targetPosition.top + tooltipDimensions.height - 25, "px");
            left = "".concat(targetPosition.left, "px");
            transform = "translate(13px, -100%)";
            break;
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    top: ", ";\n    left: ", ";\n    transform: ", ";\n  "], ["\n    top: ", ";\n    left: ", ";\n    transform: ", ";\n  "])), top, left, transform);
};
export var getTooltipClass = function (position) {
    switch (position) {
        case 'top':
            return 'tooltip--top';
        case 'bottom':
            return 'tooltip--bottom';
        case 'left':
            return 'tooltip--left';
        case 'right':
            return 'tooltip--right';
        case 'top-start':
            return 'tooltip--top-start';
        case 'top-end':
            return 'tooltip--top-end';
        case 'bottom-start':
            return 'tooltip--bottom-start';
        case 'bottom-end':
            return 'tooltip--bottom-end';
        case 'left-start':
            return 'tooltip--left-start';
        case 'left-end':
            return 'tooltip--left-end';
        case 'right-start':
            return 'tooltip--right-start';
        case 'right-end':
            return 'tooltip--right-end';
    }
};
export var getTargetPosition = function (pos, position) {
    var top = 0, left = 0;
    switch (position) {
        case 'top':
            top = pos.top;
            left = pos.left + pos.width / 2;
            break;
        case 'bottom':
            top = pos.bottom;
            left = pos.left + pos.width / 2;
            break;
        case 'left':
            top = pos.top + pos.height / 2;
            left = pos.left;
            break;
        case 'right':
            top = pos.top + pos.height / 2;
            left = pos.left + pos.width;
            break;
        case 'top-start':
            top = pos.top;
            left = pos.left;
            break;
        case 'top-end':
            top = pos.top;
            left = pos.left + pos.width;
            break;
        case 'bottom-start':
            top = pos.top + pos.height;
            left = pos.left;
            break;
        case 'bottom-end':
            top = pos.top + pos.height;
            left = pos.left + pos.width;
            break;
        case 'left-start':
            top = pos.top;
            left = pos.left;
            break;
        case 'left-end':
            top = pos.bottom;
            left = pos.left;
            break;
        case 'right-start':
            top = pos.top;
            left = pos.left + pos.width;
            break;
        case 'right-end':
            top = pos.bottom;
            left = pos.left + pos.width;
            break;
    }
    return { top: top, left: left };
};
var templateObject_1;
